import { Fragment, useContext } from "react"
// import { ActionButton } from "../../../../../../../../components"
// import { CreateModal } from "../../../CreateModal"
import { ChildItem } from "../.."
import { Delete, Detail, IsActive, Update } from "./components"
import type { DataItem, DataList } from "../../../../types"
import { useToggle } from "../../../../../../../../utils"
import { dataContext } from "pages/Setup/Preference/PaymentTermCustomer"
import { TableNumber } from "components"

export function Item(props: { item: DataList, index: number, dataList: DataItem, refetch: () => void }) {
  const { isActive } = useToggle(false)
  const { currentPage, limit, size, total } = useContext(dataContext)

  return (
    <Fragment>
      <tr>
        <td>{TableNumber({ dataLength: size, pageCurrent: currentPage, index: props.index, limit: limit, totalData: total })}</td>
        <td>{props.item.payment_term_code}</td>
        <td>{`${props.item.payment_term_name} day`}</td>
        <td>{props.item.description}</td>
        <td>
          <div className="flex items-center">
            <Detail id={props.item} />
            <Update id={props.item} refetch={props.refetch} />
            <Delete id={props.item} refetch={props.refetch} />
            <IsActive id={props.item} refetch={props.refetch} />
          </div>
        </td>
      </tr>
      {isActive && <ChildItem dataList={props.dataList} refetch={props.refetch} />}
    </Fragment>
  )
}

// function Add(props: { item: DataList }) {
//   const { isActive, toggle } = useToggle(false)

//   return (
//     <Fragment>
//       <ActionButton.Add className="join-item" onClick={toggle} />

//       {isActive && (
//         <CreateModal
//           payment_term_code={props.item.payment_term_code}
//           payment_term_name={props.item.payment_term_name}
//           description={props.item.description}
//           toggle={toggle}
//         />
//       )}
//     </Fragment>
//   )
// }